'use strict';

class GrpFeeViewCtrl {
  constructor($stateParams, $state, LoaderSvc, GrpFeeSvc, GroupAuthSvc,
    GrpFeeAmtModalSvc) {
    var that = this;
    this.groupId = $stateParams.groupId; // current group
    this.gfId = $stateParams.gfId; // current group

    if(!this.gfId) {
      return $state.go('group.view.settings.groupFee.list');
    }

    // authorization
    GroupAuthSvc.validatePermission(this.groupId, 'groupFee', 'R');

    //load groupFee
    function loadGroupFee() {
      LoaderSvc.start();
      GrpFeeSvc.get({groupId: that.groupId, id: that.gfId}).$promise
        .then(function(groupFee) {
          that.groupFee = groupFee;
          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Group Fee');
        });
    }
    loadGroupFee();

    this.openAmounts = function(grpFee, amtType) {
      GrpFeeAmtModalSvc.open(grpFee, amtType, this.groupId).then(function() {
        loadGroupFee();
      });
    };
  }
}

GrpFeeViewCtrl.$inject = [
  '$stateParams',
  '$state',
  'LoaderSvc',
  'GrpFeeSvc',
  'GroupAuthSvc',
  'GrpFeeAmtModalSvc'
];

export default GrpFeeViewCtrl;
